import { Link } from "react-router-dom";

// import { ReactComponent as BackArrow } from "../assets/icons/BackArrow.svg";
import { ReactComponent as SupportBanner } from "../assets/icons/SupportBanner.svg";
import { ReactComponent as Mail } from "../assets/icons/Mail.svg";
import { ReactComponent as Phone } from "../assets/icons/Phone.svg";
import SupportImg from "../assets/images/support-svg.svg";
import BackArrow from "../assets/images/back-arrow.svg";

const Support = () => (
  <section className="px-6 pt-2 pb-28 relative">
    <div className="flex items-center">
      <Link
        to={-1}
        className="w-9 h-9 bg-[#2D2D2D] rounded-full flex flex-row justify-center items-center"
      >
        <img src={BackArrow} alt="" />
      </Link>
      <h3 className="text-lg font-medium ml-6">Support</h3>
    </div>
    <div className="circle-blur w-[90%] h-72 mx-auto absolute left-0 right-0 top-10 blur-[60px]"></div>
    <div className="my-6 space-y-6 relative z-50">
      <div className="mb-4 flex flex-col items-center bg-[#1D1D1D]/70 rounded-[20px] pb-8 pt-4 mt-7">
        <img src={SupportImg} alt="" />
        <p className="mt-4 text-lg font-medium">How can we help you?</p>
      </div>

      <Link
        to="mailto:connect@careplix.com"
        className="px-4 py-3 rounded-[20px] flex items-center justify-between bg-[#364560] mb-0"
      >
        <div className="text-xs space-y-1.5">
          <h4 className="opacity-75 font-medium">Email</h4>
          <h6 className="text-base">connect@careplix.com</h6>
        </div>
        <Mail className="shrink-0 h-5 w-5" />
      </Link>

      <Link
        to="tel:+913341816533"
        className="px-4 py-3 rounded-[20px] flex items-center justify-between bg-secondary text-primary"
      >
        <div className="text-xs space-y-1.5">
          <h4 className="opacity-75 font-medium">Phone</h4>
          <h6 className="text-base">9147728121</h6>
        </div>
        <Phone className="shrink-0 h-5 w-5" />
      </Link>
    </div>
  </section>
);

export default Support;
